'use strict';

import $ from 'jquery';
import 'magnific-popup';

const init = () => {
    $('.nodetypes-content.image-popup').magnificPopup({
        delegate: 'a',
        type: 'image',
        tLoading: 'Loading image #%curr%...',
        mainClass: 'mfp-img-mobile',
        image: {
            titleSrc: function (item) {
                if (item.el.attr('title')) {
                    return item.el.attr('title');
                } else {
                    return null;
                }
            }
        },
        zoom: {
            enabled: false,
            duration: 100,
            easing: 'ease-in-out'
        }
    });
}

export default {init}
